<template>
  <div class="homepage-description">
    <div class="homepage-desc_content">
      <p class="homepage-desc_content_text">{{ textarea }}</p>
    </div>
  </div>
</template>

<style lang="scss">
.homepage-description {
  background: white;
  .homepage-desc_content {
    .homepage-desc_content_text {
      white-space: pre-wrap;
      font-size: 15px;
      font-weight: 400;
      color: rgba(68, 68, 68, 1);
      line-height: 24px;
    }
  }
}

@media screen and (max-width: 940px) {
  .homepage-description {
    .homepage-desc_content {
      .homepage-desc_content_text {
        white-space: pre-wrap;

        font-size: 14px;
        font-weight: 400;
        color: rgba(68, 68, 68, 1);
        line-height: 24px;
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    textarea: {
      type: String,
      default: ''
    }
  }
}
</script>
